<template>
  <div class="d-flex justify-content-between border-top pt-10">
    <div class="mr-2">
      <button
        class="btn btn-secondary font-weight-bold text-uppercase px-9 py-4"
        data-wizard-type="action-prev"
      >
        Précedent
      </button>
    </div>
    <div>
      <button
        v-on:click="submit"
        class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
        data-wizard-type="action-submit"
      >
        Valider
      </button>
      <button
        class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
        data-wizard-type="action-next"
      >
        Suivant
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    submit: function(e) {
      e.preventDefault();
      this.$emit("submit");
    }
  }
}
</script>
